import * as React from 'react'

const SvgFileQuestion = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
  >
    <path
      stroke="#475467"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.667"
      d="M16.667 7.917v-2.25c0-1.4 0-2.1-.273-2.635a2.5 2.5 0 00-1.092-1.093c-.535-.272-1.235-.272-2.635-.272H7.333c-1.4 0-2.1 0-2.635.272a2.5 2.5 0 00-1.092 1.093c-.273.534-.273 1.234-.273 2.635v8.666c0 1.4 0 2.1.273 2.635a2.5 2.5 0 001.092 1.093c.535.272 1.235.272 2.635.272h4.334m0-9.166h-5M8.333 12.5H6.667m6.666-6.667H6.667m7.083 6.669a1.873 1.873 0 013.641.624c0 1.25-1.874 1.874-1.874 1.874m.024 2.5h.009"
    ></path>
  </svg>
)

export default SvgFileQuestion
